import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ITCICardLikes, ITCILike, ITCIMarketplaceV2LikeResponse, SERVICE_URLS } from "@tci/common";
import { Http } from "@angular/http";

@Injectable()
export class NgRatingsService {
    private static instance: NgRatingsService = null;

    private likesState: ITCICardLikes = {likes: 0, connectorId: ""};
    private cardLikesUpdate$: BehaviorSubject<ITCICardLikes> = new BehaviorSubject(this.likesState);


    public static getInstance(http: Http) {
        if (!NgRatingsService.instance) {
            NgRatingsService.instance = new NgRatingsService(http);
        }
        return NgRatingsService.instance;
    }

    constructor(private http: Http) { }

    getLikeById(id: string): Observable<ITCIMarketplaceV2LikeResponse> {
        const url = `${SERVICE_URLS.MARKETPLACE}/${id}/like`;
        return this.http.get(url)
                        .map(response => <ITCIMarketplaceV2LikeResponse>response.json());
    }

    createLikebyId(id: string, likeData: ITCILike): Observable<ITCIMarketplaceV2LikeResponse> {
        const url = `${SERVICE_URLS.MARKETPLACE}/${id}/like`;
        return this.http.post(url, likeData)
                        .map(response => <ITCIMarketplaceV2LikeResponse>response.json());
    }

    updateCardLikes(likes: ITCICardLikes): void {
        this.likesState = likes;
        this.cardLikesUpdate$.next(this.likesState);
    }

    getLikesSubject(): BehaviorSubject<ITCICardLikes> {
        return this.cardLikesUpdate$;
    }
}
